import { render, staticRenderFns } from "./ManageInvitees.vue?vue&type=template&id=52fdeeab&scoped=true"
import script from "./ManageInvitees.vue?vue&type=script&lang=js"
export * from "./ManageInvitees.vue?vue&type=script&lang=js"
import style0 from "./ManageInvitees.vue?vue&type=style&index=0&id=52fdeeab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fdeeab",
  null
  
)

export default component.exports